import {createSelector} from 'reselect';
import {getSelectedDeliveryCountry} from '../selectors';
import getBillingAddressDetails from './getBillingAddressDetails';

export default createSelector(
  [getBillingAddressDetails, getSelectedDeliveryCountry],
  (billingAddress, deliveryCountry) => {
    const {useShippingAddress} = billingAddress;
  
    if (useShippingAddress) return {useShippingAddress: true};
    
    const billingAddressNoCountry = {
      useShippingAddress,
      organisationName: billingAddress.companyName || null,
      buildingNameNumber: billingAddress.nameNumber || null,
      line1: billingAddress.streetName || null,
      line2: billingAddress.addressLine2 || null,
      line3: billingAddress.townCity || null,
      line4: billingAddress.county || null,
      postcode: billingAddress.postCode || null,
    };
    
    return {
      ...billingAddressNoCountry,
      countryCode: billingAddress.country || deliveryCountry,
    };
  },
);
